var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-mining-section shadow" },
    [
      _c(
        "div",
        { staticClass: "quota-detail" },
        [_c("staking-detail", { attrs: { showVxConfirm: _vm._stake } })],
        1
      ),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "mint-trade-table no-shadow tb",
          attrs: { headList: _vm.pledgeHeadList, contentList: _vm.content }
        },
        [
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.stakeCurrentPage + 1,
              toPage: _vm.fetchMiningStake,
              totalPage: _vm.stakeTotalPage
            },
            slot: "tableBottom"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("stakeForMining", { ref: "stakeForMining" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }